import type { DisciplineCompositionGateway } from '@/application/port/out/DisciplineCompositionGateway';
import type { ListDisciplineResourcesUseCase, MutateDisciplineResourceUseCase } from '@/application/port/in/DisciplineCompositionUseCase';
import type { DisciplineResourceReference, DisciplineResourceMutation } from '@/domain/model/DisciplineComposition';
export class ListDisciplineResources implements ListDisciplineResourcesUseCase {
 constructor(private readonly gateway: DisciplineCompositionGateway) {}
 execute(reference: DisciplineResourceReference) { return this.gateway.list(reference); }
}
export class AddDisciplineResource implements MutateDisciplineResourceUseCase {
 constructor(private readonly gateway: DisciplineCompositionGateway) {}
 execute(command: DisciplineResourceMutation) { return this.gateway.add(command); }
}
export class ReorderDisciplineResource implements MutateDisciplineResourceUseCase {
 constructor(private readonly gateway: DisciplineCompositionGateway) {}
 execute(command: DisciplineResourceMutation) { return this.gateway.reorder(command); }
}
export class RemoveDisciplineResource implements MutateDisciplineResourceUseCase {
 constructor(private readonly gateway: DisciplineCompositionGateway) {}
 execute(command: DisciplineResourceMutation) { return this.gateway.remove(command); }
}
